export default __webpack_public_path__ + "static/instagram-icon-ac32ec0a111aeba03298dfc601a57e0a.png";